// Map/directions links for camp venues.
//
// No map SDK is bundled: a single venue pin doesn't justify Leaflet plus a
// tile-provider key, so previews use OpenStreetMap's keyless embed and
// directions hand off to whatever maps app the visitor already has.

// Human-readable one-line venue address, also used as the directions fallback
// when a camp has no coordinates (older camps, or an address geocoding
// couldn't resolve).
export function formatVenue({ venue_name, address, city } = {}) {
  return [venue_name, address, city].filter(Boolean).join(', ');
}

export function hasCoords(place) {
  return place?.latitude != null && place?.longitude != null;
}

// Google Maps' cross-platform directions URL — opens the native app on
// mobile and the web UI on desktop, with the visitor's own position as origin.
export function directionsUrl(place) {
  const destination = hasCoords(place)
    ? `${place.latitude},${place.longitude}`
    : formatVenue(place);
  if (!destination) return null;
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destination)}`;
}

// Keyless OpenStreetMap embed. It takes a bounding box rather than a
// zoom level, so derive a small box around the point.
export function embedUrl(place, spread = 0.006) {
  if (!hasCoords(place)) return null;
  const { latitude: lat, longitude: lng } = place;
  const bbox = [lng - spread, lat - spread, lng + spread, lat + spread].join(',');
  return `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat},${lng}`;
}
